import { render, staticRenderFns } from "./rotation-toolbox.vue?vue&type=template&id=c2e1679e&scoped=true&"
import script from "./rotation-toolbox.vue?vue&type=script&lang=ts&"
export * from "./rotation-toolbox.vue?vue&type=script&lang=ts&"
import style0 from "./rotation-toolbox.vue?vue&type=style&index=0&id=c2e1679e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e1679e",
  null
  
)

export default component.exports